import * as ActionTypes from './../actionTypes';

const initialState = {
  isLoading: false,
  data:{}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_ADMIN_USER_LISTS_REQUESTED:
      return {
        ...state,
        isLoading: true
      };

    case ActionTypes.GET_ADMIN_USER_LISTS_SUCCEEDED:
      return {
        ...state,
        isLoading: false,
        data: action.data
      };

    case ActionTypes.GET_ADMIN_USER_LISTS_FAILED:
      return {
        ...state,
        isLoading: false
      };
    default:
      return state;
  }
};
